import { render, staticRenderFns } from "./AppCards.vue?vue&type=template&id=310ae8fd&scoped=true&"
import script from "./AppCards.vue?vue&type=script&lang=js&"
export * from "./AppCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310ae8fd",
  null
  
)

export default component.exports